import { render } from "./EditPassword.vue?vue&type=template&id=2ed3e80e&ts=true"
import script from "./EditPassword.vue?vue&type=script&lang=ts"
export * from "./EditPassword.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__